export default __webpack_public_path__ + "static/media/background.1712eb34.jpg";